// extracted by mini-css-extract-plugin
module.exports = {"dotsConteiner":"Dots_dotsConteiner__PGa5I","dot":"Dots_dot__3i1L_","selected":"Dots_selected__1lQxg"};